import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RolesState } from '../reducers/roles.reducer';

export const rolesState: any = createFeatureSelector<RolesState>('roles');

export const saveRolesFailure = createSelector(rolesState, (state: any) => state.saveRolesFailure);

export const roleState: any = createFeatureSelector<RolesState>('roles');

export const rolesWithRefAndDeleted = createSelector(rolesState, (state: any) => state.rolesWithRefAndDeleted);

export const rolesTable = createSelector(roleState, (state: any) => {
  return state.data;
});

export const roleData = createSelector(roleState, (state: any) => {
  return state.sidRoleData;
});

export const rolesLoader = createSelector(roleState, (state: any) => {
  return state.loader;
});

export const searchText = createSelector(roleState, (state: any) => state.searchText);

export const allRolesSortedByName = createSelector(roleState, (state: any) => state.allRolesSortedByName);

export const sortedRolesByName = createSelector(roleState, (state: any) => state.sortedRolesByName);
